import { CharField, ImageField, SwitchField } from "@inmagik/magik-ui"
import { getIn, useFormikContext } from "formik"
import { Col } from "react-bootstrap"
import type { Story } from "../../types"
import { WysiwygField } from "../../components/WysiwygField"

export default function StoryForm({ col = 8 }: { col?: number }) {
  const { setFieldValue, values, errors, submitCount } = useFormikContext<Story>()

  return (
    <Col xs={col} className="d-flex flex-column align-items-stretch gap-4">
      <CharField
        label="Titolo"
        layout="horizontal"
        value={values.title}
        onChange={(value) => {
          setFieldValue("title", value)
        }}
        isValid={submitCount > 0 ? !getIn(errors, "title") : undefined}
        errorMessage={getIn(errors, "title")}
        required
      />
      <WysiwygField
        label="Sottotitolo"
        layout="horizontal"
        value={values.subtitle}
        onChange={(value) => {
          setFieldValue("subtitle", value)
        }}
        isValid={submitCount > 0 ? !getIn(errors, "subtitle") : undefined}
        errorMessage={getIn(errors, "subtitle")}
        required
      />
      <ImageField
        label="Immagine di copertina"
        required
        layout="horizontal"
        value={values.cover}
        onChange={(value) => {
          setFieldValue("cover", value)
        }}
        isValid={submitCount > 0 ? !getIn(errors, "cover") : undefined}
        errorMessage={getIn(errors, "cover")}
      />
      <SwitchField
        label="Bozza"
        layout="horizontal"
        value={values.draft || false}
        onChange={(checked) => {
          setFieldValue("draft", checked)
        }}
      />
    </Col>
  )
}
